setProcessing